module.exports = __webpack_public_path__ + "media/site_templates/www.waterproofing.net.au/images/about_us-b60185f2bfc2bc8da3e2dd20b41f27aa.jpg";